import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { exportCase } from "./thunks/export-case";
import { getCase } from "./thunks/get-case";
import { addAddress } from "./thunks/add-address";
import { listGeoCatalog } from "./thunks/list-geo-catalog";
import { registerInternalDelivery } from "./thunks/register-internal-delivery";
import { recordCustody } from "./thunks/record-custody";
import { updateAddress } from "./thunks/update-address";
import { replaceCapture } from "./thunks/replace-capture";
import { revealNationalId } from "./thunks/reveal-national-id";
import { searchCustomers } from "./thunks/search-customers";

const name = "compliance";

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    /** Re-mask the national id (leaving the case, or the user hides it). */
    hideNationalId(state) {
      state.revealedNationalId = null;
      state.revealedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCustomers.pending, (state) => {
        state.isSearching = true;
        state.searchError = "";
      })
      .addCase(searchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload;
        state.isSearching = false;
      })
      .addCase(searchCustomers.rejected, (state, action) => {
        state.isSearching = false;
        state.searchError = action.error.message ?? "error";
      })
      .addCase(getCase.pending, (state, action) => {
        const next = action.meta.arg.requestId;
        if (state.caseRequestId !== next) {
          // A different delivery: drop the previous case + any reveal.
          state.caseData = null;
          state.revealedNationalId = null;
          state.revealedAt = null;
        }
        state.caseRequestId = next;
        state.isCasePending = true;
        state.caseError = "";
      })
      .addCase(getCase.fulfilled, (state, action) => {
        state.caseData = action.payload;
        state.isCasePending = false;
      })
      .addCase(getCase.rejected, (state, action) => {
        state.isCasePending = false;
        state.caseError = action.error.message ?? "error";
      })
      .addCase(revealNationalId.pending, (state) => {
        state.isRevealing = true;
        state.revealError = "";
      })
      .addCase(revealNationalId.fulfilled, (state, action) => {
        state.isRevealing = false;
        state.revealedNationalId = action.payload.nationalId;
        state.revealedAt = action.payload.revealedAt;
      })
      .addCase(revealNationalId.rejected, (state, action) => {
        state.isRevealing = false;
        state.revealError = action.error.message ?? "error";
      })
      .addCase(exportCase.pending, (state) => {
        state.isExporting = true;
      })
      .addCase(exportCase.fulfilled, (state) => {
        state.isExporting = false;
      })
      .addCase(exportCase.rejected, (state) => {
        state.isExporting = false;
      })
      .addCase(replaceCapture.pending, (state) => {
        state.isReplacingCapture = true;
      })
      .addCase(replaceCapture.fulfilled, (state) => {
        state.isReplacingCapture = false;
      })
      .addCase(replaceCapture.rejected, (state) => {
        state.isReplacingCapture = false;
      })
      .addCase(recordCustody.pending, (state) => {
        state.isSavingCustody = true;
      })
      .addCase(recordCustody.fulfilled, (state) => {
        state.isSavingCustody = false;
      })
      .addCase(recordCustody.rejected, (state) => {
        state.isSavingCustody = false;
      })
      .addCase(registerInternalDelivery.pending, (state) => {
        state.isSavingState = true;
      })
      .addCase(registerInternalDelivery.fulfilled, (state) => {
        state.isSavingState = false;
      })
      .addCase(registerInternalDelivery.rejected, (state) => {
        state.isSavingState = false;
      })
      .addCase(updateAddress.pending, (state) => {
        state.isSavingAddress = true;
      })
      .addCase(updateAddress.fulfilled, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(updateAddress.rejected, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(addAddress.pending, (state) => {
        state.isSavingAddress = true;
      })
      .addCase(addAddress.fulfilled, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(addAddress.rejected, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(listGeoCatalog.fulfilled, (state, action) => {
        state.geoCatalog = action.payload;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
